import React from 'react';
import { motion } from 'framer-motion';
const benefits = [{
  icon: '🚀',
  title: 'Curriculum Scientifico e Strutturato',
  desc: 'Istruzioni chiare per ogni argomento: pensiero computazionale, Python, HTML/CSS, strutture dati, algoritmi, progetti reali.'
}, {
  icon: '💰',
  title: 'Posizionamento Professionale',
  desc: 'Materiali pronti che ti permettono di aumentare il valore percepito delle tue lezioni e distinguerti dai colleghi.'
}, {
  icon: '📱',
  title: 'Adattamenti Rapidi',
  desc: 'Moduli specifici per studenti con BES, DSA e plusdotazione, gestibili dal tuo cellulare o tablet.'
}, {
  icon: '🎓',
  title: 'Metodo Allineato al MIUR',
  desc: 'Un sistema sviluppato in coerenza con le Indicazioni Nazionali per gli Istituti Tecnici e Professionali e con il framework europeo DigComp 2.2.'
}];
export function Benefits() {
  return <section className="py-10 sm:py-12 px-4" data-id="element-21">
      <div className="max-w-6xl mx-auto" data-id="element-22">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-black text-center mb-8 uppercase text-brand-cream" data-id="element-23">
          Cosa ottieni con questo sistema
        </motion.h2>

        <div className="grid grid-cols-1 gap-4" data-id="element-24">
          {benefits.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-card border border-brand-orange/20 p-6 sm:p-8 rounded-2xl hover:border-brand-orange/50 transition-all hover:-translate-y-1" data-id="element-25">
              <div className="text-4xl mb-4" data-id="element-26">{b.icon}</div>
              <h3 className="text-xl sm:text-2xl font-bold text-brand-gold mb-3" data-id="element-27">
                {b.title}
              </h3>
              <p className="text-gray-300 font-medium leading-relaxed" data-id="element-28">
                {b.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}